import { IBAR_INFO_TYPE } from './models/IBarGuidInfoType';

export const REGULAR_BAR = 0;
export const GENERATED_BAR = 1;

export const BAR_TYPE: IBAR_INFO_TYPE = { 0: 'ー', 1: '自動生成' };
